"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RemoveFromCart = exports.AddToCart = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _buttons = require("@site/buttons");
var _domainServices = require("@site/domain-services");
var _utils = require("@site/utils");
var _button = _interopRequireDefault(require("@ux/button"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _addToCart = _interopRequireDefault(require("@ux/icon/add-to-cart"));
var _auction = _interopRequireDefault(require("@ux/icon/auction"));
var _remove = _interopRequireDefault(require("@ux/icon/remove"));
var _EidCodes = _interopRequireDefault(require("../EidCodes"));
var _SpinDefaultContinueToCart = _interopRequireDefault(require("./SpinDefaultContinueToCart"));
/* eslint-disable complexity */

const AddToCart = ({
  onManagerActionOrStateChange,
  domain,
  eidPrefix,
  getClassNames,
  getHandleOnClick,
  handleKeyDown,
  ctaIconSize,
  addProps = {},
  formatMessage,
  showGavelIcon = false
}) => {
  const defaultAddClassNames = 'btn-filled btn-link ux-button-small spin-buy-button add-to-cart spin-default-buy-button';
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    "data-cy": `${domain.Fqdn}_spin_add_to_cart_button`,
    "data-testid": `${domain.Fqdn}_spin_add_to_cart_button`,
    "data-eid": eidPrefix ? `${eidPrefix}addToCart.click` : _EidCodes.default.Domain.SpinsAddToCartButton.AddClick,
    className: addProps.classNameOverride || getClassNames(defaultAddClassNames),
    onClick: getHandleOnClick(onManagerActionOrStateChange),
    onKeyDown: handleKeyDown,
    "aria-label": formatMessage({
      id: 'ariaLabelAddItemToCart'
    }, {
      product: domain.Fqdn
    }),
    icon: /*#__PURE__*/_react.default.createElement("div", {
      "data-cy": "add-to-cart-icon-uxcore",
      className: "add-to-cart-icon-container d-inline-flex",
      "aria-hidden": true
    }, showGavelIcon ? /*#__PURE__*/_react.default.createElement(_auction.default, {
      fill: "black",
      width: ctaIconSize,
      height: ctaIconSize
    }) : /*#__PURE__*/_react.default.createElement(_addToCart.default, {
      fill: "black",
      width: ctaIconSize,
      height: ctaIconSize
    }))
  }, addProps));
};
exports.AddToCart = AddToCart;
AddToCart.propTypes = {
  onManagerActionOrStateChange: _propTypes.default.func,
  domain: _propTypes.default.object,
  eidPrefix: _propTypes.default.string,
  getClassNames: _propTypes.default.func,
  getHandleOnClick: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func,
  ctaIconSize: _propTypes.default.number,
  addProps: _propTypes.default.object,
  formatMessage: _propTypes.default.func,
  showGavelIcon: _propTypes.default.bool
};
const VerifyingCart = ({
  getClassNames,
  ctaIconSize,
  verifyingProps,
  formatMessage
}) => {
  const defaultVerifyingClassNames = 'btn-filled btn-link ux-button-small spin-buy-button add-to-cart cursor-inherit flex-column spin-default-buy-button';
  const textId = 'dppSolutionsAdding';
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    "data-cy": "spin-adding-to-cart-button",
    className: (0, _classnames.default)(getClassNames(defaultVerifyingClassNames), {
      verifying: !verifyingProps?.blackButton,
      'spin-black-button': verifyingProps?.blackButton
    }),
    "aria-label": formatMessage({
      id: textId
    }),
    icon: /*#__PURE__*/_react.default.createElement(_spinner.default, {
      size: ctaIconSize <= 24 ? 'sm' : 'md'
    })
  }, verifyingProps));
};
VerifyingCart.propTypes = {
  getClassNames: _propTypes.default.func,
  ctaIconSize: _propTypes.default.number,
  verifyingProps: _propTypes.default.object,
  formatMessage: _propTypes.default.func
};
const RemoveFromCart = ({
  onManagerActionOrStateChange,
  ContinueToCartComponent,
  domain,
  customOnClick,
  stopPropagation,
  useDefaultContinueToCart,
  host,
  defaultContinueToCartSkipConfig,
  getClassNames,
  eidPrefix,
  getHandleOnClick,
  handleKeyDown,
  ctaIconSize,
  removeProps,
  formatMessage
}) => {
  const defaultRemoveClassNames = 'btn-filled btn-link ux-button-small spin-buy-button add-to-cart cursor-inherit spin-default-buy-button';
  if (ContinueToCartComponent) {
    return /*#__PURE__*/_react.default.createElement(ContinueToCartComponent, {
      domain: domain,
      customOnClick: customOnClick,
      stopPropagation: stopPropagation
    });
  } else if (useDefaultContinueToCart) {
    return /*#__PURE__*/_react.default.createElement(_SpinDefaultContinueToCart.default, {
      host: host,
      skipConfig: defaultContinueToCartSkipConfig,
      stopPropagation: stopPropagation
    });
  }
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    className: `${getClassNames(defaultRemoveClassNames)} removing`,
    "data-cy": `${domain.Fqdn}_spin_remove_from_cart_button`,
    "data-testid": `${domain.Fqdn}_spin_remove_from_cart_button`,
    "data-eid": eidPrefix ? `${eidPrefix}removeFromCart.click` : _EidCodes.default.Domain.SpinsAddToCartButton.RemoveClick,
    "aria-label": formatMessage({
      id: 'ariaLabelRemoveItemFromCart'
    }, {
      product: domain.Fqdn
    }),
    onClick: getHandleOnClick(onManagerActionOrStateChange),
    onKeyDown: handleKeyDown,
    icon: /*#__PURE__*/_react.default.createElement("div", {
      "data-cy": "add-to-cart-icon-uxcore",
      "aria-hidden": true
    }, /*#__PURE__*/_react.default.createElement(_remove.default, {
      fill: "black",
      width: ctaIconSize,
      height: ctaIconSize
    }))
  }, removeProps));
};
exports.RemoveFromCart = RemoveFromCart;
RemoveFromCart.propTypes = {
  onManagerActionOrStateChange: _propTypes.default.func,
  ContinueToCartComponent: _propTypes.default.func,
  domain: _propTypes.default.object,
  customOnClick: _propTypes.default.func,
  stopPropagation: _propTypes.default.bool,
  useDefaultContinueToCart: _propTypes.default.bool,
  host: _propTypes.default.string,
  defaultContinueToCartSkipConfig: _propTypes.default.bool,
  getClassNames: _propTypes.default.func,
  eidPrefix: _propTypes.default.string,
  getHandleOnClick: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func,
  ctaIconSize: _propTypes.default.number,
  removeProps: _propTypes.default.object,
  formatMessage: _propTypes.default.func
};
const RemovingFromCart = ({
  getClassNames,
  ctaIconSize,
  removingProps,
  formatMessage
}) => {
  const textId = 'dppSolutionsRemoving';
  const defaultRemovingClassNames = 'btn-filled btn-link ux-button-small spin-buy-button add-to-cart cursor-inherit flex-column spin-default-buy-button';
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    className: getClassNames(defaultRemovingClassNames),
    "aria-label": formatMessage({
      id: textId
    }),
    text: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-inline-flex justify-content-center"
    }, /*#__PURE__*/_react.default.createElement(_spinner.default, {
      size: ctaIconSize <= 24 ? 'sm' : 'md'
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "ms-2 text-white font-weight-semibold"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: textId
    })))
  }, removingProps));
};
RemovingFromCart.propTypes = {
  getClassNames: _propTypes.default.func,
  ctaIconSize: _propTypes.default.number,
  removingProps: _propTypes.default.object,
  formatMessage: _propTypes.default.func
};
const SpinAddToCartButton = ({
  // State To Render The Button in (Remove or Add)
  productsInCart = false,
  // Product Specific Data to be used in SAPI Post.
  domain = {},
  product = {},
  openButton,
  productWithSapiOverrides = {},
  CustomAddToCartComponent,
  apiKey = '',
  trackingCode = '',
  plid = '1',
  market = 'en-US',
  env = '',
  resellerBaseOverride,
  basketId = '',
  dopType,
  additionalPackageAttributes = {},
  additionalPostDataAttributes = {},
  customOnClick = () => {},
  // UX / UI Related.
  buttonClassNameOverride = '',
  stopPropagation = false,
  addProps = {},
  removeProps = {},
  verifyingProps = {},
  removingProps = {},
  ContinueToCartComponent,
  CustomVerifyingCartComponent,
  CustomFailureComponent,
  CustomRemoveFromCartComponent,
  CustomRevertingComponent,
  useDefaultContinueToCart = false,
  defaultContinueToCartSkipConfig = false,
  host,
  eidPrefix,
  ctaIconSize = 28,
  // Event to use when Cart states change.
  onCartStateChange = () => {},
  traceId = '',
  // Indicates if the auctions redirect / make offer is enabled for auction domain
  showGavelIcon = false,
  customAddToCartTerms
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const products = [{
    name: domain.Fqdn,
    ...product,
    ...productWithSapiOverrides,
    ...(customAddToCartTerms && {
      term: `${(0, _utils.getDomainMonthlyTerms)({
        product: {
          domain,
          priceInfo: product.PriceInfo
        },
        domainTermsOverride: customAddToCartTerms
      })?.term}:Month`
    })
  }];
  const sapiPostData = (0, _domainServices.constructSapiPost)({
    trackingCode,
    products,
    additionalPackageAttributes,
    additionalPostDataAttributes,
    protection: dopType
  });
  const getClassNames = (defaults = '') => {
    return buttonClassNameOverride || defaults;
  };
  const getHandleOnClick = onManagerActionOrStateChange => {
    return event => {
      if (stopPropagation) {
        event.stopPropagation();
      }
      customOnClick({
        domain
      });
      onManagerActionOrStateChange();
    };
  };
  const handleKeyDown = event => {
    if (stopPropagation) {
      event.stopPropagation();
    }
  };
  const FailedCtaComponent = () => {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h6", {
      "data-cy": "unavailable_message"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "domainFailedAvailCheck"
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_buttons.AddToCartManager, {
    onCartStateChange: onCartStateChange,
    ctaComplete: productsInCart,
    sapiPostData: sapiPostData,
    trackingCode: trackingCode,
    plid: plid,
    basketId: basketId,
    apiKey: apiKey,
    market: market,
    env: env,
    traceId: traceId,
    formatMessage: formatMessage,
    resellerBaseOverride: resellerBaseOverride,
    openButton: openButton,
    ctaIconSize: ctaIconSize,
    handleKeyDown: handleKeyDown,
    getHandleOnClick: getHandleOnClick,
    getClassNames: getClassNames,
    addProps: addProps,
    removeProps: removeProps,
    verifyingProps: verifyingProps,
    removingProps: removingProps,
    ContinueToCartComponent: ContinueToCartComponent,
    useDefaultContinueToCart: useDefaultContinueToCart,
    defaultContinueToCartSkipConfig: defaultContinueToCartSkipConfig,
    host: host,
    eidPrefix: eidPrefix,
    domain: domain,
    stopPropagation: stopPropagation,
    customComponents: {
      CustomAddToCartComponent: CustomAddToCartComponent || AddToCart,
      CustomRemoveFromCartComponent: CustomRemoveFromCartComponent || RemoveFromCart,
      CustomRunningComponent: CustomVerifyingCartComponent || VerifyingCart,
      CustomRevertingComponent: CustomRevertingComponent || RemovingFromCart,
      CustomFailureComponent: CustomFailureComponent || FailedCtaComponent
    },
    showGavelIcon: showGavelIcon,
    customButtonProps: {
      failureProps: {
        ctaIconSize,
        getClassNames
      }
    }
  });
};
SpinAddToCartButton.propTypes = {
  domain: _propTypes.default.object,
  product: _propTypes.default.object.isRequired,
  productWithSapiOverrides: _propTypes.default.shape({
    name: _propTypes.default.string,
    packageIdOverride: _propTypes.default.string,
    term: _propTypes.default.string,
    phase: _propTypes.default.string,
    redemptioncode: _propTypes.default.string
  }),
  apiKey: _propTypes.default.string,
  CustomAddToCartComponent: _propTypes.default.func,
  trackingCode: _propTypes.default.string,
  productsInCart: _propTypes.default.bool,
  plid: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  market: _propTypes.default.string,
  env: _propTypes.default.string,
  resellerBaseOverride: _propTypes.default.string,
  basketId: _propTypes.default.string,
  additionalPackageAttributes: _propTypes.default.object,
  additionalPostDataAttributes: _propTypes.default.object,
  customOnClick: _propTypes.default.func,
  buttonClassNameOverride: _propTypes.default.string,
  stopPropagation: _propTypes.default.bool,
  addProps: _propTypes.default.object,
  removeProps: _propTypes.default.object,
  verifyingProps: _propTypes.default.object,
  removingProps: _propTypes.default.object,
  onCartStateChange: _propTypes.default.func,
  ContinueToCartComponent: _propTypes.default.func,
  useDefaultContinueToCart: _propTypes.default.bool,
  defaultContinueToCartSkipConfig: _propTypes.default.bool,
  host: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  ctaIconSize: _propTypes.default.number,
  traceId: _propTypes.default.string,
  openButton: _propTypes.default.bool,
  CustomVerifyingCartComponent: _propTypes.default.func,
  CustomFailureComponent: _propTypes.default.func,
  CustomRemoveFromCartComponent: _propTypes.default.func,
  CustomRevertingComponent: _propTypes.default.func,
  dopType: _propTypes.default.string,
  showGavelIcon: _propTypes.default.bool
};
var _default = exports.default = SpinAddToCartButton;